import { useJwt } from "react-jwt";

let initialState = { token: null, };
const SetJwtToken = (state = initialState, action) => {
     
  switch (action.type) {
    case "SET_JWT_TOKEN":
      console.log("action.payload in setJwtToken", action.payload);
      return { ...state, token: action.payload};
    

    default:
      return state;
  }
};

export default SetJwtToken;
